<template>
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
        <transition-group name="slide-fade">
            <div v-for="alert in alerts" :key="alert.id" class="toast show align-items-center border-0 shadow-lg mb-2"
                :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                <div class="d-flex p-3">
                    <i :class="alert.icon" class="me-3 fs-5"></i>
                    <div class="toast-body p-0 fw-medium">
                        {{ alert.message }}
                    </div>
                    <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                </div>
            </div>
        </transition-group>
    </div>
    <div class="modal fade" id="modalClient" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-0">
                    <h4 class="fw-bold m-0 text-dark">{{ isEditing ? 'Editar Cliente' : 'Novo Cliente' }}</h4>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>

                <div class="px-4 pt-4">
                    <ul class="nav nav-tabs nav-tabs-pmg" id="clientTab" role="tablist">
                        <li class="nav-item"><button class="nav-link active" id="main-tab" data-bs-toggle="tab"
                                data-bs-target="#pane-main" type="button">Dados Principais</button></li>
                        <li class="nav-item"><button class="nav-link" data-bs-toggle="tab"
                                data-bs-target="#pane-address" type="button">Endereço</button></li>
                        <li class="nav-item"><button class="nav-link" data-bs-toggle="tab"
                                data-bs-target="#pane-personal" type="button">Dados Pessoais</button></li>
                        <li class="nav-item"><button class="nav-link" data-bs-toggle="tab"
                                data-bs-target="#pane-branches" type="button">Empresas</button></li>
                        <li class="nav-item"><button class="nav-link" data-bs-toggle="tab" data-bs-target="#pane-other"
                                type="button">Outros</button></li>
                    </ul>
                </div>

                <div class="modal-body px-4 py-4">
                    <div class="tab-content">
                        <div class="tab-pane fade show active" id="pane-main" role="tabpanel">
                            <div class="row g-4">
                                <div class="col-md-12">
                                    <label class="form-label fw-bold text-secondary small mb-1">Nome Completo
                                        *</label>
                                    <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: João Silva Sauro">
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="form-label small fw-bold">CNPJ/CPF *</label>
                                        <div class="input-group">
                                            <input type="text" class="form-control"
                                                :class="{ 'is-invalid': documentError }" v-model="form.document"
                                                placeholder="Digite apenas números" @blur="handleDocumentBlur"
                                                maxlength="18">
                                            <button class="btn btn-outline-primary" type="button" @click="searchCnpj"
                                                :disabled="isSearchingCnpj || (form.document?.replace(/\D/g, '').length < 14)">
                                                <span v-if="isSearchingCnpj"
                                                    class="spinner-border spinner-border-sm"></span>
                                                <i v-else class="bi bi-search"></i>
                                            </button>
                                        </div>
                                        <div v-if="documentError" class="invalid-feedback d-block small fw-bold mt-1">
                                            {{ documentError }}
                                        </div>
                                        <small class="text-muted tiny">Digite 14 dígitos para habilitar a consulta
                                            automática.</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label fw-bold text-secondary small">Telefone *</label>
                                    <input v-model="form.phone" @input="applyPhoneMask" type="text"
                                        class="form-control form-control-pmg" placeholder="(00) 00000-0000">
                                </div>
                                <div class="col-md-8">
                                    <label class="form-label fw-bold text-secondary small mb-1">E-mail</label>
                                    <input v-model="form.email" type="email" class="form-control form-control-pmg"
                                        placeholder="exemplo@email.com">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">Status</label>
                                    <select v-model="form.status" class="form-select form-control-pmg">
                                        <option value="ativo">Ativo</option>
                                        <option value="inativo">Inativo</option>
                                        <option value="inadimplente">Inadimplente</option>
                                        <option value="bloqueado">Bloqueado</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="pane-address" role="tabpanel">
                            <div class="row g-4">
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">CEP</label>
                                    <input v-model="form.zip_code" @input="applyCepMask" @blur="fetchAddressByCep"
                                        type="text" class="form-control form-control-pmg" placeholder="00000-000">
                                </div>
                                <div class="col-md-8">
                                    <label class="form-label fw-bold text-secondary small mb-1">Logradouro e
                                        número</label>
                                    <input v-model="form.street" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: Rua Paulista, nº 122">
                                </div>
                                <div class="col-md-5">
                                    <label class="form-label fw-bold text-secondary small mb-1">Bairro</label>
                                    <input v-model="form.neighborhood" type="text" class="form-control form-control-pmg"
                                        placeholder="Digite o bairro">
                                </div>
                                <div class="col-md-5">
                                    <label class="form-label fw-bold text-secondary small mb-1">Cidade</label>
                                    <input v-model="form.city" type="text" class="form-control form-control-pmg"
                                        placeholder="Cidade">
                                </div>
                                <div class="col-md-2">
                                    <label class="form-label fw-bold text-secondary small mb-1">UF</label>
                                    <input v-model="form.state" type="text"
                                        class="form-control form-control-pmg text-uppercase" placeholder="UF"
                                        maxlength="2">
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="pane-personal" role="tabpanel">
                            <div class="row g-4">
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">Estado Civil</label>
                                    <select v-model="form.marital_status" class="form-select form-control-pmg">
                                        <option value="" disabled selected>Selecione o estado civil...</option>
                                        <option value="Solteiro(a)">Solteiro(a)</option>
                                        <option value="Casado(a)">Casado(a)</option>
                                        <option value="União Estável">União Estável</option>
                                        <option value="Separado(a) judicialmente">Separado(a) judicialmente</option>
                                        <option value="Divorciado(a)">Divorciado(a)</option>
                                        <option value="Viúvo(a)">Viúvo(a)</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">Escolaridade</label>
                                    <select v-model="form.education_level" class="form-select form-control-pmg">
                                        <option value="" disabled selected>Selecione a escolaridade...</option>
                                        <option value="Ensino Fundamental I Incompleto">Ensino Fundamental I
                                            Incompleto</option>
                                        <option value="Ensino Fundamental I Completo">Ensino Fundamental I Completo
                                        </option>
                                        <option value="Ensino Fundamental II Incompleto">Ensino Fundamental II
                                            Incompleto</option>
                                        <option value="Ensino Fundamental II Completo">Ensino Fundamental II
                                            Completo</option>
                                        <option value="Ensino Médio Incompleto">Ensino Médio Incompleto</option>
                                        <option value="Ensino Médio Completo">Ensino Médio Completo</option>
                                        <option value="Ensino Superior Incompleto">Ensino Superior Incompleto
                                        </option>
                                        <option value="Ensino Superior Completo">Ensino Superior Completo</option>
                                        <option value="Pós-graduação">Pós-graduação</option>
                                        <option value="Mestrado">Mestrado</option>
                                        <option value="Doutorado">Doutorado</option>
                                        <option value="Pós-Doutorado">Pós-Doutorado</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">Profissão</label>
                                    <input v-model="form.occupation" type="text" class="form-control form-control-pmg"
                                        placeholder="Ex: Analista">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label fw-bold text-secondary small mb-1">RG</label>
                                    <input v-model="form.id_document" type="text" class="form-control form-control-pmg"
                                        placeholder="Número do RG">
                                </div>
                                <div class="col-md-8">
                                    <label class="form-label fw-bold text-secondary small mb-1">CNH</label>
                                    <input v-model="form.driver_license" type="text"
                                        class="form-control form-control-pmg" placeholder="Número da CNH">
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="pane-ged" role="tabpanel">
                            <div v-if="isEditing && form.documents_existing?.length" class="mb-4">
                                <h6 class="text-uppercase text-muted fw-bold small mb-3">Documentos Arquivados</h6>
                                <div class="row g-2">
                                    <div v-for="doc in form.documents_existing" :key="doc.id" class="col-md-6">
                                        <div class="d-flex align-items-center p-2 border rounded bg-light">
                                            <div class="me-2">
                                                <i :class="getFileIcon(doc.file_type)" class="fs-4"></i>
                                            </div>
                                            <div class="flex-grow-1 text-truncate">
                                                <div class="small fw-bold text-dark text-truncate">{{ doc.file_name
                                                    }}</div>
                                                <div class="tiny text-muted">{{ doc.file_size }}</div>
                                            </div>
                                            <div class="d-flex gap-1">
                                                <button type="button" @click="handleViewOrDownload(doc)"
                                                    class="btn btn-sm btn-light border"
                                                    :title="isViewable(doc) ? 'Visualizar' : 'Baixar'">
                                                    <i :class="isViewable(doc) ? 'bi bi-eye' : 'bi bi-download'"></i>
                                                </button>

                                                <button type="button" @click="downloadFile(doc)"
                                                    class="btn btn-sm btn-light border text-primary"
                                                    title="Baixar Arquivo">
                                                    <i class="bi bi-download"></i>
                                                </button>

                                                <button type="button" @click="confirmDeleteDoc(doc.id)"
                                                    class="btn btn-sm btn-light border text-danger" title="Excluir">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="upload-area p-4 border-2 border-dashed rounded text-center bg-light-subtle">
                                <input type="file" ref="fileInput" @change="handleFileSelection" multiple class="d-none"
                                    accept=".pdf,.jpg,.jpeg,.png">
                                <i class="bi bi-cloud-arrow-up fs-1 text-primary opacity-50"></i>
                                <p class="mt-2 mb-3 small text-muted">Arraste arquivos ou clique para selecionar</p>
                                <button type="button" class="btn btn-sm btn-pmg-primary"
                                    @click="$refs.fileInput.click()">
                                    Selecionar Arquivos
                                </button>
                            </div>
                            <div v-if="newFilesPreview.length" class="mt-3">
                                <div v-for="(file, index) in newFilesPreview" :key="index"
                                    class="d-flex align-items-center p-2 mb-1 bg-white border-start border-3 border-primary rounded shadow-sm">
                                    <i class="bi bi-file-earmark-plus me-2 text-primary"></i>
                                    <span class="small flex-grow-1">{{ file.name }}</span>
                                    <button @click="removeNewFile(index)" class="btn btn-sm text-danger"><i
                                            class="bi bi-x-circle"></i></button>
                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="pane-other" role="tabpanel">
                            <div class="row g-4">
                                <div class="col-md-6">
                                    <label class="form-label fw-bold text-secondary small mb-1">Limite de Crédito
                                        (R$)</label>
                                    <div class="input-group">
                                        <span class="input-group-text bg-light border-end-0 text-muted small">R$</span>
                                        <input type="text" v-model="form.credit_limit" @input="maskCurrency"
                                            class="form-control form-control-pmg ps-1" placeholder="0,00">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label fw-bold text-secondary small mb-1">Score Interno
                                        (0-1000)</label>
                                    <input v-model="form.internal_score" type="number"
                                        class="form-control form-control-pmg" placeholder="Ex: 850">
                                    <div class="form-text tiny">Define a cor de risco do cliente na listagem.</div>
                                </div>
                            </div>
                            <label class="form-label fw-bold text-secondary small mb-1">Observações Internas</label>
                            <textarea v-model="form.notes" class="form-control form-control-pmg" rows="5"
                                placeholder="Digite detalhes relevantes sobre este cliente..."></textarea>
                        </div>
                        <div class="tab-pane fade" id="pane-branches" role="tabpanel">
                            <div class="row g-4">
                                <!-- Input de Pesquisa com Autocomplete (Mantido igual ao seu) -->
                                <div class="col-md-12">
                                    <label class="form-label fw-bold text-secondary small mb-1">Pesquisar e Vincular
                                        Empresa</label>
                                    <div class="position-relative">
                                        <input type="text" class="form-control form-control-pmg"
                                            v-model="branchSearchQuery" @input="searchBranchesDebounced"
                                            placeholder="Digite o nome da empresa para buscar...">

                                        <!-- Dropdown de Resultados -->
                                        <div v-if="branchSearchResults.length > 0"
                                            class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                            style="z-index: 1060; max-height: 250px; overflow-y: auto;">
                                            <ul class="list-unstyled mb-0">
                                                <li v-for="branch in branchSearchResults" :key="branch.id"
                                                    @mousedown.prevent="selectBranch(branch)"
                                                    class="p-3 autocomplete-item border-bottom cursor-pointer text-dark">
                                                    <div class="fw-bold"> <i class="bi bi-building me-2 text-primary"></i> {{ branch.name }}</div>
                                                    <div class="small text-muted" v-if="branch.document">
                                                        CNPJ/Doc: {{ branch.document }}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <!-- Lista de Empresas Vinculadas em formato de CARDS (Padrão Fornecedor) -->
                                <div class="col-md-12 mt-4" v-if="selectedBranches?.length > 0">
                                    <h6 class="text-uppercase text-muted fw-bold small mb-3">
                                        Empresas Vinculadas ({{ selectedBranches.length }})
                                    </h6>

                                    <div class="row g-2">
                                        <div v-for="(branch, index) in selectedBranches" :key="branch.id || index"
                                            class="col-md-6">
                                            <div
                                                class="d-flex align-items-center justify-content-between p-2 border rounded bg-white shadow-sm">

                                                <div class="d-flex align-items-center overflow-hidden">
                                                    <i class="bi bi-building fs-5 text-secondary me-2"></i>
                                                    <div class="fw-bold small text-dark text-truncate">{{ branch.name }}
                                                    </div>
                                                </div>

                                                <button type="button" @click="removeBranch(index)"
                                                    class="btn btn-sm text-danger ms-2 p-1" title="Remover">
                                                    <i class="bi bi-x-lg"></i>
                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Estado Vazio -->
                                <div class="col-md-12 mt-4 text-center" v-else>
                                    <div class="p-4 bg-light rounded border border-dashed">
                                        <i class="bi bi-buildings fs-1 text-muted opacity-50 mb-2"></i>
                                        <p class="text-muted small mb-0">Nenhuma empresa vinculada a este cliente no
                                            momento.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer border-0 pb-4 px-4">
                    <button type="button" class="btn btn-pmg-light me-2" @click="closeModal">Cancelar</button>
                    <button class="btn btn-pmg-primary px-4" @click="saveClient" :disabled="loading || !isFormValid">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span> Salvar Cliente
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import { clientModalState } from '@/utils/clientModalState';


export default {
    inject: ['globalLoading'],
    name: 'ClientModal',
    data() {
        return {
            isDestroying: false,
            clients: [], alerts: [], loading: false, isEditing: false, showFilter: false,
            filter: { search: '' }, selectedIds: [], totalItems: 0, currentPage: 1, lastPage: 1, hasMore: false,
            form: {
                id: null, name: '', document: '', email: '', phone: '', status: 'ativo',
                zip_code: '', street: '', neighborhood: '', city: '', state: '',
                education_level: '', occupation: '', marital_status: '',
                id_document: '', driver_license: '', notes: '', documents: []
            },
            clientFiles: [], selectedFiles: [],
            modalInstance: null, deleteModalInstance: null, detailsModalInstance: null,
            itemToDelete: null, isBulkDelete: false, selectedClient: null,
            showOccurrenceForm: false,
            newOccurrence: { type: 'contato', description: '' },
            newFilesPreview: [],
            docIdToDelete: null,
            modalDeleteInstance: null,
            selectedClientGed: null,
            modalGedInstance: null,
            errors: {},
            loadingGed: false,
            uploadStats: {
                total: 0,
                sent: 0,
                percentage: 0,
                currentFileName: ''
            },

            searchingCnpj: false,

            loadingReport: false,
            reportModalInstance: null,
            cities: [],

            clientToReanalyze: null,
            reanalyzeModalInstance: null,
            reanalyzing: false,
            isSearchingCnpj: false,
            branch_ids: [],

            branchSearchQuery: '',
            branchSearchResults: [],
            selectedBranches: [],
            branchSearchTimeout: null,
        }
    },
    beforeUnmount() {
        this.isDestroying = true; // Avisa que o componente está morrendo
    },
    watch: {

        isOpen(newVal) {
            if (newVal) {
                // O pulo do gato: Só é edição se tiver um ID real da transação!
                const isEditMode = this.modalData && this.modalData.id;

                // Se for edição, passa os dados. Se for novo, força passar null.
                this.initModal(isEditMode ? 'edit' : 'create', isEditMode ? this.modalData : null);

                if (this.modalInstance) {
                    this.modalInstance.show();
                }
            } else {
                if (this.modalInstance) {
                    this.modalInstance.hide();
                }
            }
        },
        'form.document'(newVal) {
            if (!newVal) {
                this.documentError = null;
                return;
            }

            // Pega apenas os números
            let rawValue = newVal.replace(/\D/g, "");
            let maskedValue = rawValue;

            // Aplica a máscara
            if (rawValue.length <= 11) {
                maskedValue = maskedValue.replace(/(\d{3})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/(\d{3})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            } else {
                maskedValue = maskedValue.replace(/^(\d{2})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                maskedValue = maskedValue.replace(/\.(\d{3})(\d)/, ".$1/$2");
                maskedValue = maskedValue.replace(/(\d{4})(\d)/, "$1-$2");
            }

            // Se a máscara modificou o valor que o usuário digitou, atualiza o form e para aqui.
            // O Vue vai disparar este watch novamente automaticamente com o valor já formatado.
            if (newVal !== maskedValue) {
                this.form.document = maskedValue;
                return;
            }

            // VALIDAÇÃO INSTANTÂNEA E EXATA
            if (rawValue.length === 11) {
                this.documentError = this.validateCPF(rawValue) ? null : 'CPF inválido.';
            } else if (rawValue.length === 14) {
                this.documentError = this.validateCNPJ(rawValue) ? null : 'CNPJ inválido.';
            } else if (rawValue.length > 11 && rawValue.length < 14) {
                this.documentError = 'Documento incompleto (CNPJ exige 14 números).';
            } else if (rawValue.length > 14) {
                this.documentError = 'CNPJ inválido.';
            } else {
                this.documentError = null;
            }
        }
    },
    directives: {
        tooltip: {
            mounted(el, binding) {
                new window.bootstrap.Tooltip(el, {
                    title: binding.value,
                    placement: 'top',
                    trigger: 'hover',
                    customClass: 'custom-tooltip-ia' // Classe opcional para estilizar ainda mais
                });
            },
            updated(el, binding) {
                const tooltip = window.bootstrap.Tooltip.getInstance(el);
                if (tooltip) {
                    tooltip.setContent({ '.tooltip-inner': binding.value });
                }
            },
            beforeUnmount(el) {
                const tooltip = window.bootstrap.Tooltip.getInstance(el);
                if (tooltip) {
                    tooltip.dispose();
                }
            }
        }
    },
    computed: {
        isOpen() { return clientModalState.isOpen; },
        modalData() { return clientModalState.data; },
        isAllSelected() { return this.clients.length > 0 && this.selectedIds.length === this.clients.length; },
        isReportValid() { return this.reportFilters.fields.length >= 2; },
        isFormValid() {
            // 1. Verifica se os campos obrigatórios estão preenchidos
            const hasRequiredFields = !!(
                this.form.name && this.form.name.trim() !== '' &&
                this.form.document && this.form.document.trim() !== '' &&
                this.form.phone && this.form.phone.trim() !== ''
            );

            // 2. Garante que o documento tenha exatamente 11 (CPF) ou 14 (CNPJ) dígitos numéricos
            const rawDocument = this.form.document ? this.form.document.replace(/\D/g, '') : '';
            const isDocumentComplete = rawDocument.length === 11 || rawDocument.length === 14;

            // 3. Retorna verdadeiro APENAS se tem os campos, o documento está completo e NÃO há erros matemáticos
            return hasRequiredFields && isDocumentComplete && !this.documentError;
        },
        selectAllFields: {
            get() {
                // Verifica se todos os itens disponíveis estão presentes no array de filtros
                return this.reportFilters.fields.length === this.availableFields.length;
            },
            set(value) {
                if (value) {
                    // Preenche o array com todos os IDs
                    this.reportFilters.fields = this.availableFields.map(f => f.id);
                } else {
                    // Esvazia o array
                    this.reportFilters.fields = [];
                }
            }
        },

        activeSuggestions() {
            const suggestions = this.selectedClient?.data_quality_analysis?.suggestions;
            console.log(suggestions);
            if (!suggestions) return [];
            return Object.keys(suggestions)
                .filter(key => suggestions[key] !== null && suggestions[key] !== '')
                .map(key => ({
                    field: key,
                    text: suggestions[key]
                }));
        }
    },

    mounted() {
        const modalElement = document.getElementById('modalClient');
        if (modalElement) {
            this.modalInstance = new window.bootstrap.Modal(modalElement);
            modalElement.addEventListener('hidden.bs.modal', () => {
            if (this.isOpen) {
               this.closeModal();
            }
        });
        }

        this.fetchClients();
    },
    methods: {

        initModal(mode, item = null) {
            this.isEditing = (mode === 'edit');

            if (this.isEditing && item) {
                this.form = { ...item };
                if (item.address) {
                    this.form.zip_code = item.address.zip_code;
                    this.form.street = item.address.street;
                    this.form.neighborhood = item.address.neighborhood;
                    this.form.city = item.address.city;
                    this.form.state = item.address.state;
                    this.form.documents_existing = item.documents || [];
                    this.form.documents = [];
                }

                if (item.personal_data) {
                    this.form.education_level = item.personal_data.education_level;
                    this.form.occupation = item.personal_data.occupation;
                    this.form.marital_status = item.personal_data.marital_status;
                }

                if (item.extra_documents) {
                    this.form.id_document = item.extra_documents.id_document;
                    this.form.id_issue_agency = item.extra_documents.id_issue_agency;
                    this.form.id_issue_state = item.extra_documents.id_issue_state;
                    this.form.driver_license = item.extra_documents.driver_license;
                }
                if (item.branches) {
                    this.selectedBranches = [...item.branches];
                    this.form.branch_ids = item.branches.map(b => b.id);
                } else {
                    this.selectedBranches = [];
                    this.form.branch_ids = [];
                }

                this.form.credit_limit = item.credit_limit_formatted;
            } else {
                // Reset para novo cadastro
                this.form = {
                    id: null, name: '', document: '', email: '', phone: '', status: 'ativo',
                    zip_code: '', street: '', neighborhood: '', city: '', state: '',
                    education_level: '', occupation: '', marital_status: '',
                    id_document: '', id_issue_agency: '', id_issue_state: '', driver_license: '', notes: ''
                };
                this.selectedBranches = [];
                this.form.branch_ids = [];
                this.branchSearchQuery = '';
                this.branchSearchResults = [];
            }

            this.modalInstance.show();
        },
        async searchExternalCnpj() {
            if (!this.form.document) return;

            this.searchingCnpj = true;
            const cnpjClear = this.form.document ? this.form.document.replace(/\D/g, '') : '';
            try {
                const response = await api.get(`/external/cnpj/${cnpjClear}`);
                const data = response.data;

                // Preenchimento automático dos campos
                this.form.name = data.razao_social;
                this.form.nickname = data.nome_fantasia;
                this.form.zip_code = data.cep;
                this.form.street = data.logradouro;
                this.form.neighborhood = data.bairro;
                this.form.city = data.cidade;
                this.form.state = data.uf;
                this.form.phone = data.telefone;
                this.form.email = data.email;

                this.showAlert("Dados importados com sucesso!");
            } catch (e) {
                const msg = e.response?.data?.message || "CNPJ não encontrado ou erro na API.";
                this.showAlert(msg, "error");
            } finally {
                this.searchingCnpj = false;
            }
        },

        async fetchClients(page = 1, append = false) {
            this.globalLoading.show('Carregando clientes...');
            this.loading = true;
            try {
                const res = await api.get('/clients', { params: { page, search: this.filter.search } });
                const { data, meta } = res.data;
                this.clients = append ? [...this.clients, ...data] : data;
                this.totalItems = meta.total;
                this.currentPage = meta.current_page;
                this.lastPage = meta.last_page;
                this.hasMore = this.currentPage < this.lastPage;
            } catch (e) { this.showAlert("Erro ao buscar dados.", "error"); }
            finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        getFileIcon(type) {
            const icons = {
                pdf: 'bi bi-file-earmark-pdf text-danger',
                jpg: 'bi bi-file-earmark-image text-primary',
                jpeg: 'bi bi-file-earmark-image text-primary',
                png: 'bi bi-file-earmark-image text-success',
            };
            return icons[type?.toLowerCase()] || 'bi bi-file-earmark-text';
        },

        openModal(mode, item = null) {
            this.isEditing = (mode === 'edit');

            if (this.isEditing && item) {
                this.form = { ...item };
                if (item.address) {
                    this.form.zip_code = item.address.zip_code;
                    this.form.street = item.address.street;
                    this.form.neighborhood = item.address.neighborhood;
                    this.form.city = item.address.city;
                    this.form.state = item.address.state;
                    this.form.documents_existing = item.documents || [];
                    this.form.documents = [];
                }

                if (item.personal_data) {
                    this.form.education_level = item.personal_data.education_level;
                    this.form.occupation = item.personal_data.occupation;
                    this.form.marital_status = item.personal_data.marital_status;
                }

                if (item.extra_documents) {
                    this.form.id_document = item.extra_documents.id_document;
                    this.form.id_issue_agency = item.extra_documents.id_issue_agency;
                    this.form.id_issue_state = item.extra_documents.id_issue_state;
                    this.form.driver_license = item.extra_documents.driver_license;
                }

                this.form.credit_limit = item.credit_limit_formatted;
            } else {
                // Reset para novo cadastro
                this.form = {
                    id: null, name: '', document: '', email: '', phone: '', status: 'active',
                    zip_code: '', street: '', neighborhood: '', city: '', state: '',
                    education_level: '', occupation: '', marital_status: '',
                    id_document: '', id_issue_agency: '', id_issue_state: '', driver_license: '', notes: ''
                };
            }

            this.modalInstance.show();
        },

        async directUploadDocument(file, clientId) {
            try {
                const { data } = await api.post(`/clients/${clientId}/documents/upload-link`, {
                    fileName: file.name,
                    mimeType: file.type
                });

                await fetch(data.uploadUrl, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': file.type
                    },
                    body: file
                });

                // Modificação aqui: capturar a resposta do Laravel
                const response = await api.post(`/clients/${clientId}/documents/confirm`, {
                    provider_id: data.providerFileId,
                    file_name: file.name,
                    verify_ia: false
                });

                // Retorna o documento que o Laravel acabou de salvar no banco
                return response.data;

            } catch (e) {
                console.error('Falha no upload direto do arquivo:', file.name, e);
                throw e;
            }
        },

        async saveClient() {
            if (!this.isFormValid) return;

            this.loading = true;
            this.errors = {}; // Essencial: Limpa os erros de tentativas anteriores

            try {
                this.globalLoading.show('Salvando cliente...');

                const payload = {
                    name: this.form.name,
                    document: this.form.document,
                    email: this.form.email,
                    phone: this.form.phone,
                    credit_limit: this.form.credit_limit || 0,
                    internal_score: this.form.internal_score || 100,
                    notes: this.form.notes || '',
                    zip_code: this.form.zip_code,
                    street: this.form.street,
                    neighborhood: this.form.neighborhood,
                    city: this.form.city,
                    state: this.form.state,
                    education_level: this.form.education_level,
                    occupation: this.form.occupation,
                    marital_status: this.form.marital_status,
                    id_document: this.form.id_document,
                    driver_license: this.form.driver_license,
                    status: this.form.status,
                    branch_ids: this.form.branch_ids
                };

                // Lógica mantida: Diferencia Update (PUT) de Create (POST)
                const url = this.isEditing ? `/clients/${this.form.id}` : '/clients';
                const method = this.isEditing ? 'put' : 'post';

                // Envia a requisição
                const response = await api[method](url, payload);

                // Lógica mantida: Captura o ID correto dependendo da ação
                const clientId = this.isEditing ? this.form.id : (response.data.data?.id || response.data.id);

                // Lógica mantida: Upload direto pro GED
                if (this.form.documents && this.form.documents.length > 0 && clientId) {
                    for (const file of this.form.documents) {
                        if (file instanceof File) {
                            await this.directUploadDocument(file, clientId);
                        }
                    }
                }

                clientModalState.notifySuccess();
                clientModalState.close();

            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                } else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar.", "error");
                }
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            if (this.deleteModalInstance) this.deleteModalInstance.show();
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) await api.post('/clients/bulk-delete', { ids: this.selectedIds });
                else await api.delete(`/clients/${this.itemToDelete.id}`);
                this.showAlert("Excluído com sucesso!", "danger");
                this.selectedIds = [];
                this.fetchClients(1, false);
            } catch (e) { this.showAlert("Erro ao excluir.", "error"); }
            finally { if (this.deleteModalInstance) this.deleteModalInstance.hide(); }
        },

        // Helper Alertas e Miscs
        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamação-triangle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },
        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },

        async fetchAddressByCep() {
            const cep = this.form.zip_code.replace(/\D/g, '');
            if (cep.length === 8) {
                try {
                    const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                    const d = await r.json();
                    if (!d.erro) {
                        this.form.street = d.logradouro;
                        this.form.neighborhood = d.bairro;
                        this.form.city = d.localidade;
                        this.form.state = d.uf;
                    }
                } catch (e) { console.error(e); }
            }
        },

        applyDocumentMask(e) {
            // Pega o valor exato do momento da digitação e limpa formatações
            let rawValue = e.target.value.replace(/\D/g, "");

            // 1. Aplica a máscara correspondente (CPF ou CNPJ)
            let maskedValue = rawValue;
            if (rawValue.length <= 11) {
                maskedValue = maskedValue.replace(/(\d{3})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/(\d{3})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            } else {
                maskedValue = maskedValue.replace(/^(\d{2})(\d)/, "$1.$2");
                maskedValue = maskedValue.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                maskedValue = maskedValue.replace(/\.(\d{3})(\d)/, ".$1/$2");
                maskedValue = maskedValue.replace(/(\d{4})(\d)/, "$1-$2");
            }

            // Atualiza o v-model do Vue com a máscara aplicada
            this.form.document = maskedValue;

            // 2. Validação rigorosa e INSTANTÂNEA
            if (rawValue.length === 11) {
                this.documentError = this.validateCPF(rawValue) ? null : 'CPF inválido.';
            } else if (rawValue.length === 14) {
                this.documentError = this.validateCNPJ(rawValue) ? null : 'CNPJ inválido.';
            } else if (rawValue.length > 11 && rawValue.length < 14) {
                this.documentError = 'Documento incompleto (CNPJ exige 14 números).';
            } else if (rawValue.length > 14) {
                this.documentError = 'CNPJ inválido.';
            } else {
                // Limpa o erro enquanto o usuário ainda está digitando os primeiros 10 dígitos
                this.documentError = null;
            }
        },
        applyPhoneMask(e) {
            let v = e.target.value.replace(/\D/g, "");

            // Limita a 11 dígitos no total (tamanho máximo que atende Celulares e 0800)
            if (v.length > 11) {
                v = v.substring(0, 11);
            }

            // Verifica se é um número especial (0800 ou 0300)
            if (v.startsWith("0800") || v.startsWith("0300")) {
                if (v.length > 7) {
                    // Formato: 0800 000 0000
                    v = v.replace(/^(\d{4})(\d{3})(\d{0,4}).*/, "$1 $2 $3");
                } else if (v.length > 4) {
                    // Formato: 0800 000...
                    v = v.replace(/^(\d{4})(\d{0,3})/, "$1 $2");
                }
            } else {
                // Formatação Padrão: Fixo e Celular com DDD
                if (v.length > 10) {
                    // Celular: (99) 99999-9999
                    v = v.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
                } else if (v.length > 6) {
                    // Fixo completo: (99) 9999-9999
                    v = v.replace(/^(\d{2})(\d{4})(\d+)/, "($1) $2-$3");
                } else if (v.length > 2) {
                    // Apenas DDD e início do número: (99) 99...
                    v = v.replace(/^(\d{2})(\d+)/, "($1) $2");
                } else if (v.length > 0) {
                    // Apenas dígito inicial do DDD: (9
                    v = v.replace(/^(\d*)/, "($1");
                }
            }

            this.form.phone = v;
        },
        maskCurrency(e) {
            let v = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número

            // Transforma em valor monetário formatado (ex: 125050 -> 1.250,50)
            v = (Number(v) / 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            this.form.credit_limit = v;
        },
        applyCepMask() { this.form.zip_code = this.form.zip_code.replace(/\D/g, '').replace(/^(\d{5})(\d)/, "$1-$2"); },
        handleFileSelection(e) {
            const selectedFiles = Array.from(e.target.files);

            if (!Array.isArray(this.form.documents)) {
                this.form.documents = [];
            }

            this.form.documents = [...this.form.documents, ...selectedFiles];
            this.newFilesPreview = [...this.newFilesPreview, ...selectedFiles];

            e.target.value = '';
        },
        removeNewFile(index) {
            this.form.documents.splice(index, 1);
            this.newFilesPreview.splice(index, 1);
        },
        removeFile(i) { this.clientFiles.splice(i, 1); this.selectedFiles.splice(i, 1); },
        toggleAll(e) { this.selectedIds = e.target.checked ? this.clients.map(c => c.id) : []; },
        applyFilter() { this.showFilter = false; this.fetchClients(1, false); },
        loadMore() { if (this.hasMore) this.fetchClients(this.currentPage + 1, true); },
        openDetails(item) {
            this.selectedClient = item;
            if (this.detailsModalInstance) {
                this.detailsModalInstance.show();
            } else {
                const myModal = new window.bootstrap.Modal(document.getElementById('modalClientDetails'));
                myModal.show();
            }
        },

        cleanPhone(phone) {
            if (!phone) return '';
            return phone.replace(/\D/g, '');
        },


        formatMoney(value) {
            return parseFloat(value || 0).toLocaleString('pt-br', { minimumFractionDigits: 2 });
        },

        async fetchCitiesFromIBGE(uf) {
            this.loadingCities = true;
            try {
                const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
                const data = await response.json();
                this.cities = data;
            } catch (error) {
                console.error("Erro ao carregar cidades do IBGE", error);
                this.showAlert("Não foi possível carregar as cidades.", "error");
            } finally {
                this.loadingCities = false;
            }
        },
        isViewable(doc) {
            // Verifica se a extensão é de imagem ou PDF
            const ext = doc.file_type ? doc.file_type.toLowerCase() : doc.url.split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'pdf', 'webp'].includes(ext);
        },
        closeModal() {
            clientModalState.close();
        },
        validateCPF(cpf) {
            cpf = cpf.replace(/[^\d]+/g, '');
            if (cpf === '') return false;

            // Bloqueia CPFs com dígitos repetidos (Falso Positivos)
            if (cpf.length !== 11 ||
                cpf === "00000000000" || cpf === "11111111111" ||
                cpf === "22222222222" || cpf === "33333333333" ||
                cpf === "44444444444" || cpf === "55555555555" ||
                cpf === "66666666666" || cpf === "77777777777" ||
                cpf === "88888888888" || cpf === "99999999999") {
                return false;
            }

            // Validação do 1º Dígito
            let add = 0;
            for (let i = 0; i < 9; i++) {
                add += parseInt(cpf.charAt(i)) * (10 - i);
            }
            let rev = 11 - (add % 11);
            if (rev === 10 || rev === 11) rev = 0;
            if (rev !== parseInt(cpf.charAt(9))) return false;

            // Validação do 2º Dígito
            add = 0;
            for (let i = 0; i < 10; i++) {
                add += parseInt(cpf.charAt(i)) * (11 - i);
            }
            rev = 11 - (add % 11);
            if (rev === 10 || rev === 11) rev = 0;
            if (rev !== parseInt(cpf.charAt(10))) return false;

            return true;
        },

        validateCNPJ(cnpj) {
            if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
            let size = cnpj.length - 2;
            let numbers = cnpj.substring(0, size);
            let digits = cnpj.substring(size);
            let sum = 0;
            let pos = size - 7;
            for (let i = size; i >= 1; i--) {
                sum += parseInt(numbers.charAt(size - i)) * pos--;
                if (pos < 2) pos = 9;
            }
            let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
            if (result !== parseInt(digits.charAt(0))) return false;
            size = size + 1;
            numbers = cnpj.substring(0, size);
            sum = 0;
            pos = size - 7;
            for (let i = size; i >= 1; i--) {
                sum += parseInt(numbers.charAt(size - i)) * pos--;
                if (pos < 2) pos = 9;
            }
            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
            return result === parseInt(digits.charAt(1));
        },
        handleDocumentBlur() {
            const rawValue = this.form.document ? this.form.document.replace(/\D/g, '') : '';
            if (rawValue === '') {
                this.documentError = null;
                return;
            }

            if (rawValue.length <= 11) {
                this.documentError = this.validateCPF(rawValue) ? null : 'CPF inválido.';
            } else {
                this.documentError = this.validateCNPJ(rawValue) ? null : 'CNPJ inválido.';
            }
        },
        async searchCnpj() {
            this.globalLoading.show('Carregando dados...');
            const cnpjClear = this.form.document ? this.form.document.replace(/\D/g, '') : '';
            if (cnpjClear.length !== 14) return;

            this.isSearchingCnpj = true;

            try {
                const response = await api.get(`/external/cnpj/${cnpjClear}`);
                const data = response.data;

                this.form.name = data.razao_social || data.nome_fantasia || this.form.name;
                this.form.email = data.email || this.form.email;
                if (data.telefone) {
                    let v = data.telefone.replace(/\D/g, "");
                    if (v.length > 11) v = v.substring(0, 11);
                    if (v.length > 10) v = v.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
                    else if (v.length > 6) v = v.replace(/^(\d{2})(\d{4})(\d+)/, "($1) $2-$3");
                    else if (v.length > 2) v = v.replace(/^(\d{2})(\d+)/, "($1) $2");
                    else if (v.length > 0) v = v.replace(/^(\d*)/, "($1");
                    this.form.phone = v;
                }

                if (data.cep) {
                    this.form.zip_code = data.cep.replace(/\D/g, '').replace(/^(\d{5})(\d)/, "$1-$2");
                }

                this.form.street = data.logradouro || this.form.street;
                this.form.neighborhood = data.bairro || this.form.neighborhood;
                this.form.city = data.cidade || this.form.city;
                this.form.state = data.uf || this.form.state;

            } catch (e) {
                console.error("Erro ao buscar CNPJ:", e);
            } finally {
                this.isSearchingCnpj = false;
                this.globalLoading.hide();
            }
        },
        searchBranchesDebounced() {
            clearTimeout(this.branchSearchTimeout);
            this.branchSearchTimeout = setTimeout(() => {
                this.searchBranches();
            }, 300);
        },

        async searchBranches() {
            if (!this.branchSearchQuery || this.branchSearchQuery.length < 2) {
                this.branchSearchResults = [];
                return;
            }

            try {
                const res = await api.get('/branches', {
                    params: { search: this.branchSearchQuery, per_page: 10 }
                });
                const data = res.data.data || res.data;
                this.branchSearchResults = data.filter(b => !this.form.branch_ids.includes(b.id));
            } catch (e) {
                console.error("Erro ao buscar Empresas", e);
            }
        },

        selectBranch(branch) {
            console.log(branch);
            this.selectedBranches.push(branch);
            this.form.branch_ids.push(branch.id);
            this.branchSearchQuery = '';
            this.branchSearchResults = [];
        },

        removeBranch(index) {
            this.selectedBranches.splice(index, 1);
            this.form.branch_ids.splice(index, 1);
        }
    }
}
</script>

<style scoped>
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

/* Unificando o tamanho e comportamento de todos os botões da RMR */
.btn-pmg-primary,
.btn-pmg-light,
.btn-pmg-danger {
    padding: 10px 24px !important;
    /* Aumentamos um pouco o preenchimento lateral */
    border-radius: 10px;
    font-weight: 500;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    height: 45px;
    /* Fixamos a altura para garantir simetria total */
}

/* Cores específicas para o Primary */
.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
}

.btn-pmg-primary:hover {
    background: #1a294d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(33, 51, 97, 0.2);
}

/* Cores específicas para o Light */
.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
}

.btn-pmg-light:hover {
    background-color: #f8fafc;
    color: #1e293b;
    border-color: #cbd5e1;
}

/* Cores específicas para o Danger */
.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}

.form-control-pmg {
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding: 10px 14px;
}

.nav-tabs-pmg .nav-link.active {
    color: #561569;
    border-bottom: 3px solid #561569;
    background: transparent;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.pointer {
    cursor: pointer;
}

.tiny {
    font-size: 0.7rem;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

/* TABS ESTILO PRODUTO (REVISADO) */
.nav-tabs-pmg {
    border-bottom: 1px solid #e2e8f0;
    gap: 2rem;
    border-top: none;
    border-left: none;
    border-right: none;
}

.nav-tabs-pmg .nav-link {
    border: none !important;
    color: #94a3b8 !important;
    font-weight: 600;
    padding: 0.5rem 0;
    background: transparent !important;
    font-size: 0.95rem;
    transition: color 0.2s ease;
}

.nav-tabs-pmg .nav-link.active {
    color: #561569 !important;
    border-bottom: 3px solid #561569 !important;
    background: transparent !important;
}

.nav-tabs-pmg .nav-link:hover:not(.active) {
    color: #64748b !important;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.timeline-item {
    position: relative;
    padding-bottom: 1.5rem;
}

.bg-secondary-subtle {
    background-color: #f1f5f9 !important;
    color: #475569 !important;
    font-size: 0.65rem !important;
    letter-spacing: 0.5px;
}

.border-light-subtle {
    border-color: #e2e8f0 !important;
}

.tiny {
    font-size: 0.75rem;
}

/* Container da Timeline */
.audit-timeline {
    position: relative;
    border-left: 2px solid #e2e8f0;
    margin-left: 10px;
    padding-left: 20px !important;
}

/* Item da Auditoria */
.audit-item {
    position: relative;
}

.audit-item::before {
    content: '';
    position: absolute;
    left: -26px;
    top: 5px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #561569;
}

/* Badges de Ação */
.badge-action {
    font-size: 0.65rem;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 800;
    letter-spacing: 0.5px;
}

.badge-creation {
    background: #dcfce7;
    color: #15803d;
}

.badge-update {
    background: #eff6ff;
    color: #1d4ed8;
}

.badge-deletion {
    background: #fee2e2;
    color: #b91c1c;
}

/* Card de Mudanças */
.audit-changes-card {
    background-color: #f8fafc;
    border-radius: 12px;
    padding: 1rem;
    border: 1px solid #f1f5f9;
}

.change-row {
    padding: 8px 0;
    border-bottom: 1px solid #edf2f7;
}

.change-row:last-child {
    border-bottom: none;
}

.change-label {
    font-size: 0.65rem;
    color: #64748b;
    font-weight: 700;
    margin-bottom: 2px;
}

.old-value,
.new-value {
    font-size: 0.85rem;
}

.line-height-1 {
    line-height: 1.2;
}

#modalDeleteDoc {
    z-index: 1080 !important;
}

#modalDeleteDoc~.modal-backdrop {
    z-index: 1070 !important;
}

.bg-pmg-light {
    background-color: rgba(13, 110, 253, 0.1);
}

.bg-success-light {
    background-color: rgba(25, 135, 84, 0.1);
}

.bg-danger-light {
    background-color: rgba(220, 53, 69, 0.1);
}

.bg-warning-light {
    background-color: rgba(255, 193, 7, 0.1);
}

.table-danger-light {
    background-color: rgba(220, 53, 69, 0.05) !important;
}


.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

:deep(.tooltip-inner) {
    background-color: #1e293b;
    font-size: 0.75rem;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

:deep(.bs-tooltip-top .tooltip-arrow::before) {
    border-top-color: #1e293b;
}

.upload-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    /* Tela escura */
    backdrop-filter: blur(4px);
    /* Efeito de desfoque moderno */
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-card {
    width: 100%;
    max-width: 450px;
    border: none;
    animation: slideUp 0.3s ease-out;
}

.spinner-growth {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 5px;
    display: inline-block;
    vertical-align: -0.125em;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    animation: 0.75s linear infinite spinner-grow;
}

@keyframes slideUp {
    from {
        transform: translateY(20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes spinner-grow {
    0% {
        transform: scale(0);
    }

    50% {
        opacity: 1;
        transform: none;
    }
}

.progress-bar {
    transition: width 0.4s ease;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    /* Vermelho muito claro */
    color: #991b1b !important;
    /* Vermelho escuro para o texto */
    border-left: 5px solid #ef4444 !important;
    /* Borda viva */
}

.dropdown-menu {
    z-index: 1050 !important;
}

.table-responsive {
    overflow: visible !important;
}

.autocomplete-item {
    transition: background-color 0.2s ease;
}

.autocomplete-item:hover {
    background-color: #f1f5f9;
}

.cursor-pointer {
    cursor: pointer;
}
</style>